"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsModule = void 0;
var inversify_1 = require("inversify");
var interfaces_1 = require("@dp-instant/interfaces");
var index_1 = require("./index");
exports.NotificationsModule = new inversify_1.ContainerModule(function (bind) {
    bind(interfaces_1.TypesNotification.i18n).toConstantValue({
        play_turn: {
            default: "{username} is playing with you.",
            localizations: {
                zh_TW: "{username}正在與你一同遊玩。",
                zh_CN: "{username} 正在和你玩。",
                fr_FR: "{username} joue avec vous.",
                de_DE: "{username} spielt mit dir.",
                id_ID: "{username} bermain bersamamu.",
                it_IT: "{username} sta giocando con te.",
                ja_JP: "{username} があなたとプレイしています。",
                ko_KR: "{username}이 여러분과 함께 플레이하고 있습니다.",
                ms_MY: "{username} sedang bermain dengan anda.",
                pl_PL: "{username} gra z Tobą.",
                pt_BR: "{username} está jogando com você.",
                pt_PT: "{username} está a jogar contigo.",
                es_ES: "{username} está jugando contigo.",
                es_LA: "{username} está jugando contigo.",
                th_TH: "{username} กำลังเล่นกับคุณ",
                tr_TR: "{username} seninle oynuyor.",
                vi_VN: "{username} đang chơi với bạn.",
                ru_RU: "{username} играет с вами."
            }
        },
        play_won_0: {
            default: "{username} won with score {score}.",
            localizations: {
                zh_TW: "{username}獲得了{score}分。",
                zh_CN: "{username} 获胜，得分 {score}。",
                fr_FR: "{username} a gagné avec un score de {score}.",
                de_DE: "{username} hat gewonnen mit dem Ergebnis {score}.",
                id_ID: "{username} menang dengan skor {score}.",
                it_IT: "{username} ha vinto con {score} punti.",
                ja_JP: "{username} はスコア {score} で勝ちました。",
                ko_KR: "{username}이 {score}을 득점하여 승리했습니다.",
                ms_MY: "{username} menang dengan skor {score}.",
                pl_PL: "{username} zdobył {score} i wygrał.`",
                pt_BR: "{username} venceu, com uma pontuação de {score}.",
                pt_PT: "{username} venceu, com uma pontuação de {score}.",
                es_ES: "{username} ha ganado con una puntuación de {score}.",
                es_LA: "{username} ganó con un puntaje de {score}.",
                th_TH: "{username} ชนะด้วยคะแนน {score}",
                tr_TR: "{username}, {score} puan alarak oyunu kazandı.",
                vi_VN: "{username} đã chiến thắng với số điểm {score}.",
                ru_RU: "{username} побеждает со счетом {score}."
            }
        },
        play_won_1: {
            default: "{username} wins!",
            localizations: {
                zh_TW: "{username}獲勝了！",
                zh_CN: "{username} 获胜！",
                fr_FR: "Victoire de {username} !",
                de_DE: "{username} gewinnt!",
                id_ID: "{username} menang!",
                it_IT: "{username} ha vinto!",
                ja_JP: "{username} の勝ち！",
                ko_KR: "{username} 승리!",
                ms_MY: "{username} menang! ",
                pl_PL: "Wygrywa {username}!",
                pt_BR: "Vitória de {username}!",
                pt_PT: "Vitória do {username}!",
                es_ES: "¡Victoria para {username}!",
                es_LA: "¡Gana {username}!",
                th_TH: "{username} ชนะ!",
                tr_TR: "{username} kazandı!",
                vi_VN: "{username} chiến thắng!",
                ru_RU: "{username} побеждает!"
            }
        },
        play_won_2: {
            default: "{username} scored {score}. Try to beat!",
            localizations: {
                zh_TW: "{username}獲得了{score}分。試著打敗他吧！",
                zh_CN: "{username} 得分 {score}。努力打败！",
                fr_FR: "Le score de {username} est {score}. Essayez de le battre !",
                de_DE: "{username} hat {score}. Schlage ihn!",
                id_ID: "{username} meraih skor {score}. Coba kalahkan!",
                it_IT: "{username} ha realizzato {score}. Prova a superare il suo punteggio!",
                ja_JP: "{username} のスコアは {score}でした。打倒だ！",
                ko_KR: "{username} 득점 {score}. 겨루어 보세요!",
                ms_MY: "{username} mendapat skor {score}. Cuba tewaskan!",
                pl_PL: "{username} zdobył {score}. Spróbuj pobić ten wynik!",
                pt_BR: "{username} marcou {score}. Tente superar essa marca!",
                pt_PT: "{username} marcou {score}. Tenta superar essa marca!",
                es_ES: "{username} ha obtenido una puntuación de {score}. ¡Intenta superarla!",
                es_LA: "{username} tiene un puntaje de {score}. ¡Intenta vencerlo!",
                th_TH: "{username} ทำคะแนนได้ {score} พยายามเอาชนะเขาให้ได้!",
                tr_TR: "{username}, {score} puan aldı. Geçmeyi dene!",
                vi_VN: "{username} đã ghi điểm {score}. Cố gắng đánh bại!",
                ru_RU: "{username} набрал {score}. Попробуй набрать больше!"
            }
        },
        play_won_3: {
            default: "Try to beat {username}!",
            localizations: {
                zh_TW: "挑戰{username}吧！",
                zh_CN: "努力打败 {username}！",
                fr_FR: "Essayez de battre {username} !",
                de_DE: "Versuche {username}, zu schlagen!",
                id_ID: "Coba kalahkan {username}!",
                it_IT: "Prova a superare il punteggio di {username}!",
                ja_JP: "{username}に勝とう！",
                ko_KR: "{username}과 겨루어 보세요!",
                ms_MY: "Cuba tewaskan {username}!",
                pl_PL: "Spróbuj pokonać gracza {username}!",
                pt_BR: "Tente superar {username}!",
                pt_PT: "Tenta superar {username}!",
                es_ES: "¡Intenta vencer a {username}!",
                es_LA: "¡Intenta vencer a {username}!",
                th_TH: "พยายามเอาชนะ{username}ให้ได้!",
                tr_TR: "{username} adlı oyuncuyu geçmeyi dene!",
                vi_VN: "Cố gắng đánh bại {username}!",
                ru_RU: "Попробуй набрать больше, чем {username}!"
            }
        }
    });
    bind(interfaces_1.TypesNotification.start).to(index_1.NAStart);
    bind(interfaces_1.TypesNotification.leave).to(index_1.NALeave);
    bind(interfaces_1.TypesNotification.finish).to(index_1.NAFinish);
});
//# sourceMappingURL=NotificationsModule.js.map